import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DomainWizard } from '@/components/DomainWizard/DomainWizard';

export function DomainSetup() {
  return (
    <div>
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 mb-6"
      >
        <ArrowLeft className="w-4 h-4" />
        Back to Dashboard
      </Link>

      <div className="mb-8 text-center">
        <h1 className="text-2xl font-bold mb-2">Add New Domain</h1>
        <p className="text-slate-600">
          Follow the steps below to connect your subdomain to SitemapHost
        </p>
      </div>

      <DomainWizard />
    </div>
  );
}
